export const CONSULT_STATUS = {
  InProgress: 'In Progress',
  ConsultCompleted: 'Consult Completed',
  Cancelled: 'Cancelled',
  // Emergency: 'Emergency',
  // ProcessSummary: 'Process Summary',
  // Paid: 'Paid',
  Done: 'Done',
  ReadyToPay: 'Ready To Pay',
  AwaitingAddressConfirmation: 'Waiting Confirmation',
  InDelivery: 'In Delivery',
};

export const CONSULT_STATUS_COLORS = {
  [CONSULT_STATUS.InProgress]: {
    txt: '#23A6CC',
    background: '#23a6cc29',
  },
  [CONSULT_STATUS.ConsultCompleted]: {
    txt: '#AD5E99',
    background: '#FFE9FB',
  },
  [CONSULT_STATUS.Done]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
  [CONSULT_STATUS.ReadyToPay]: {
    txt: '#3C7D0E',
    background: '#83cc2629',
  },
  [CONSULT_STATUS.AwaitingAddressConfirmation]: {
    txt: '#3C7D0E',
    background: '#83cc2629',
  },
  [CONSULT_STATUS.InDelivery]: {
    txt: '#E37F2A',
    background: '#e37f2a29',
  },
  [CONSULT_STATUS.Cancelled]: {
    txt: '#333333',
    background: '#F1F1F1',
  },
};
